module.exports = __webpack_public_path__ + "ath_game_web/img/5.3.362afe87.png";